"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmOrderToJSON = exports.ConfirmOrderFromJSONTyped = exports.ConfirmOrderFromJSON = exports.instanceOfConfirmOrder = void 0;
var runtime_1 = require("../runtime");
var ConfirmOrderCampaign_1 = require("./ConfirmOrderCampaign");
var ConfirmOrderOrderInner_1 = require("./ConfirmOrderOrderInner");
var ConfirmOrderShipping_1 = require("./ConfirmOrderShipping");
/**
 * Check if a given object implements the ConfirmOrder interface.
 */
function instanceOfConfirmOrder(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfConfirmOrder = instanceOfConfirmOrder;
function ConfirmOrderFromJSON(json) {
    return ConfirmOrderFromJSONTyped(json, false);
}
exports.ConfirmOrderFromJSON = ConfirmOrderFromJSON;
function ConfirmOrderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'storeOwnerEmail': !(0, runtime_1.exists)(json, 'store_owner_email') ? undefined : json['store_owner_email'],
        'campaign': !(0, runtime_1.exists)(json, 'campaign') ? undefined : (0, ConfirmOrderCampaign_1.ConfirmOrderCampaignFromJSON)(json['campaign']),
        'shipping': !(0, runtime_1.exists)(json, 'shipping') ? undefined : (0, ConfirmOrderShipping_1.ConfirmOrderShippingFromJSON)(json['shipping']),
        'order': !(0, runtime_1.exists)(json, 'order') ? undefined : (json['order'].map(ConfirmOrderOrderInner_1.ConfirmOrderOrderInnerFromJSON)),
    };
}
exports.ConfirmOrderFromJSONTyped = ConfirmOrderFromJSONTyped;
function ConfirmOrderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'store_owner_email': value.storeOwnerEmail,
        'campaign': (0, ConfirmOrderCampaign_1.ConfirmOrderCampaignToJSON)(value.campaign),
        'shipping': (0, ConfirmOrderShipping_1.ConfirmOrderShippingToJSON)(value.shipping),
        'order': value.order === undefined ? undefined : (value.order.map(ConfirmOrderOrderInner_1.ConfirmOrderOrderInnerToJSON)),
    };
}
exports.ConfirmOrderToJSON = ConfirmOrderToJSON;
